import BasicList from 'src/features/common/BasicList';
import LeadSummaryView from 'src/features/leads/view/LeadSummaryView';
import { ActivityDialogStore, ActivityHistoryDialogStore, ActivityNotesDialogStore, CadenceListDialogStore, CompanyDialogStore, DailpadPopupStore, HistoryDetailsDialogStore, Lead, LeadScreenStore, SprintDialogStore, ViewType } from "src/stores/LeadStore"
import { leadEndpoints } from 'src/configs/endpoints';
import { LeadListStore } from 'src/stores/LeadStore'
import { List, PagedList } from 'src/types/common';
import ActivityDialog from '../view/ActivityDialog';
import EditDialog from '../view/EditDialog';
import DoActivityAccountLeadDialog from '../view/DoActivityAccountLeadDialog';
import DoActivitySecondaryDialog from '../view/DoActivitySecondaryDialog';
import { OptionWithSelect } from '../../autocomplete/types';
import { Filter } from '../../filters/FilterTypes';
import DialPadDialog from '../view/DialPadDialog';

type Props = {
    searchTerm: string,
    /*filters: OptionWithSelect[],*/
    filter: Filter
}

const LeadsList = ({ filter, searchTerm }: Props) => {
    /*const filters = LeadScreenStore.useState(s => s.filters);*/

    const list = LeadListStore.useState(s => s.list);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead);
    const selectedView = LeadScreenStore.useState(s => s.selectedView);
    const isNewPopup = LeadScreenStore.useState(s => s.isNewPopup);
   

    const handleEditLeadConfirm = async () => {
        onClose();
    };

    const onClose = async () => {
        LeadScreenStore.update(s => { s.isNewPopup = false })
    };

    const handleActivityConfirm = async () => {
        LeadScreenStore.update(s => { s.selectedLead = null });
    };
    const updateList = (list: PagedList<Lead>) => {
        LeadListStore.update(s => {
            s.list = list
        });
    }

    


    return <>
        <BasicList queryRecordsEndpoint={leadEndpoints.getLeads} filter={filter} listName='leads-list' Component={LeadSummaryView} list={list} updateList={updateList} searchTerm={searchTerm} />
        
        {selectedLead && isNewPopup && <EditDialog open={selectedLead != null} onCancel={onClose} onConfirm={() => handleEditLeadConfirm()} title="Edit Lead" />}
    </>

}

export { LeadsList }

export default LeadsList;